import { type ProgressSummary } from '@/services/api'
import styles from './WinsSection.module.css'

interface Props {
  summary: ProgressSummary
}

interface Win {
  emoji: string
  text: string
}

function getWins(summary: ProgressSummary): Win[] {
  const wins: Win[] = []

  if (summary.current_streak >= 7) {
    wins.push({ emoji: '', text: `${summary.current_streak}-day streak! Amazing!` })
  } else if (summary.current_streak >= 3) {
    wins.push({ emoji: '', text: `${summary.current_streak}-day streak! Keep going!` })
  }

  if (summary.this_week >= 5) {
    wins.push({ emoji: '', text: 'Super active week!' })
  } else if (summary.this_week >= 3) {
    wins.push({ emoji: '', text: 'Active week!' })
  }

  if (summary.total >= 50) {
    wins.push({ emoji: '', text: `${summary.total} activities completed!` })
  } else if (summary.total >= 20) {
    wins.push({ emoji: '', text: `${summary.total} activities and counting!` })
  } else if (summary.total >= 10) {
    wins.push({ emoji: '', text: 'Great progress so far!' })
  }

  if (summary.longest_streak >= 7) {
    wins.push({ emoji: '', text: `Best streak: ${summary.longest_streak} days!` })
  }

  if (wins.length === 0) {
    wins.push({ emoji: '', text: 'Every activity makes a difference!' })
  }

  return wins
}

export default function WinsSection({ summary }: Props) {
  const wins = getWins(summary)

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Your Wins</h3>
      <div className={styles.list}>
        {wins.map((win, i) => (
          <div key={i} className={styles.win}>
            <span className={styles.emoji}>{win.emoji}</span>
            <span className={styles.text}>{win.text}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
